import React from "react";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import Divider from "@mui/material/Divider";
import { ThemeProvider } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { StaffSelection } from "@/components/Filter/staffSelection";
import { AddOutlined } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

import constant from "@/config/constant";

// CSS
import "@/styles/page/employeeShopping.css";
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";

// Mui Icon
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";

// Fetch
import { createQuestionnarieSettings } from "@/fetch/fetchQuestionnarie";
import { getAllPromoter } from "@/fetch/fetchStaff";

// Moment
import Moment from "moment";
import { extendMoment } from "moment-range";
import "moment/locale/zh-hk";

const QuestionnaireCreatePage = (props) => {
  const { open, setOpen } = props;
  const moment = extendMoment(Moment);

  // Navigate
  const navigate = useNavigate();

  // States
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [optionList, setOptionList] = React.useState([]);
  const [isErrorFormGroup, setIsErrorFormGroup] = React.useState([
    {
      type: "",
      labelname: "",
      optionValue: "",
    },
  ]);
  const [isErrorFormDetail, setIsErrorFormDetail] = React.useState({
    title: "",
    promoter: "",
  });
  const [formDetail, setFormDetail] = React.useState({
    title: "",
    promoter: [],
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
  });
  const [formGroup, setFormGroup] = React.useState([
    {
      type: constant.boxValue[0].type,
      labelName: "",
      optionValue: Array(2).fill({ value: "", label: "" }),
    },
  ]);
  const formGroupCopy = [...formGroup];

  const handleSubmit = async () => {
    const newFormGroup = {
      ...formDetail,
      field_value: formGroup,
    };

    const isErrorFormDetail = {
      title: formDetail.title ? "" : "不能為空值",
      promoter: formDetail.promoter.length > 0 ? "" : "不能為空值",
    };

    const isErrorFormGroup = newFormGroup.field_value.map((item) => {
      const secondError =
        item.type !== "uploadFile" &&
        item.type !== "textField" &&
        item.type !== "please select" &&
        item.type !== "dropDownWithProduct"
          ? item.optionValue.map((innerItem) => ({
              label: innerItem.label ? "" : "不能為空值",
              value: innerItem.value ? "" : "不能為空值",
            }))
          : item.optionValue.map(() => ({
              label: "",
              value: "",
            }));

      return {
        type: item.type !== "please select" ? "" : "請選擇",
        labelname: item.labelName ? "" : "不能為空值",
        optionValue: secondError,
      };
    });

    const isErrorFormDetailSet = Object.values(isErrorFormDetail).some(
      (item) => item && true
    );

    const isErrorFormGroupSet = isErrorFormGroup.some((item) => {
      const optionValue = item.optionValue.some((item) => {
        const optionValueItem = Object.values(item).some(
          (item) => item && true
        );
        return optionValueItem;
      });
      if (item.type || item.labelname || optionValue) return true;
    });

    if (isErrorFormDetailSet) {
      setIsErrorFormDetail(isErrorFormDetail);
      return false;
    }

    if (isErrorFormGroupSet) {
      setIsErrorFormGroup(isErrorFormGroup);
      return false;
    }

    try {
      const { data } = await createQuestionnarieSettings(newFormGroup);
      if (data.id) {
        setSnackMessage("已新增");
        setSnackSeverity("success");
        setSnackOpen(true);
        await new Promise((resolve) =>
          setTimeout(() => resolve(navigate("/questionnaireConfig")), 500)
        );
      } else {
        setSnackMessage("新增失敗");
        setSnackSeverity("error");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setSnackOpen(true);
    }
  };

  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };

  const fetchAll = async () => {
    try {
      const { data } = await getAllPromoter();
      const newData = data.sort((a, b) =>
        a.work_location[0].districts.localeCompare(b.work_location[0].districts)
      );
      if (data) setOptionList(newData);
    } catch (err) {
      console.log(err);
    }
  };

  React.useEffect(() => {
    fetchAll();
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="StaffManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`問卷表格設定 / 新增`}
        history={() => navigate(-1)}
        children={
          <div>
            <IconButton
              component="label"
              onClick={() => {
                const temp = [...formGroup];
                temp.push({
                  type: constant.boxValue[0].type,
                  labelName: "",
                  optionValue: Array(2).fill({
                    value: "",
                    label: "",
                  }),
                });
                setFormGroup(temp);
              }}
            >
              <AddOutlined />
            </IconButton>
            <IconButton component="label" onClick={handleSubmit}>
              <SaveIcon />
            </IconButton>
          </div>
        }
      />
      <UpperForm
        {...{ formDetail, setFormDetail, isErrorFormDetail, optionList }}
      />
      {formGroup.map((item, index) => {
        return (
          <StyledPaper page={"yes"} key={index}>
            <ThemeProvider theme={{}}>
              <Box validate="true" sx={{ width: 1, flex: 1 }}>
                <Grid container spacing={2}>
                  <Grid
                    container
                    rowGap={2}
                    alignContent={"flex-start"}
                    size={{
                      xs: 12,
                      md: 2,
                      lg: 2,
                    }}
                  >
                    <FormControl
                      error={!!isErrorFormGroup[index]?.type}
                      fullWidth
                    >
                      <InputLabel id="demo-simple-select-label">
                        類別
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={item.type}
                        label="類別"
                        onChange={(event) => {
                          const temp = { ...formGroupCopy[index] };
                          temp["type"] = event.target.value;
                          formGroupCopy[index] = temp;
                          setFormGroup(formGroupCopy);
                        }}
                      >
                        {constant.boxValue.map((item, index) => {
                          return (
                            <MenuItem
                              value={item.type}
                              key={index}
                              disabled={index === 0}
                            >
                              {item.display}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <FormHelperText>
                        {isErrorFormGroup[index]?.type}
                      </FormHelperText>
                    </FormControl>
                    {(formGroup[index]["type"] === "dropDown" ||
                      formGroup[index]["type"] === "checkBox") && (
                      <TextField
                        value={formGroup[index]["optionValue"]["length"]}
                        onChange={(event) => {
                          const temp = { ...formGroupCopy[index] };
                          temp["optionValue"] = Array(
                            parseInt(event.target.value) || 0
                          ).fill({ label: "", value: "" });
                          formGroupCopy[index] = temp;
                          setFormGroup(formGroupCopy);
                        }}
                        helperText={`請輸入 ${formGroup[index]["type"]} 數量`}
                        id="demo-helper-text-aligned"
                      />
                    )}
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    size={{
                      xs: 12,
                      md: 10,
                      lg: 10,
                    }}
                  >
                    <FormText
                      parentIndex={index}
                      formGroup={formGroup}
                      display={item.display}
                      type={item.type}
                      handleChange={setFormGroup}
                      isErrorFormGroup={isErrorFormGroup}
                    />
                  </Grid>
                </Grid>
              </Box>
            </ThemeProvider>
          </StyledPaper>
        );
      })}
    </Layout>
  );
};

export default QuestionnaireCreatePage;

function FormText(props) {
  const isErrorFormGroup = props?.isErrorFormGroup;
  const parentIndex = props?.parentIndex;
  const formGroup = [...props?.formGroup];
  const optionValue = [...formGroup[parentIndex]["optionValue"]];
  const optionValueCopy = [...formGroup[parentIndex]["optionValue"]];

  return (
    <React.Fragment>
      <Grid
        size={{
          xs: 12,
          md: 2,
          lg: 2,
        }}
      >
        <TextField
          error={!!isErrorFormGroup[parentIndex]?.labelname}
          value={formGroup[parentIndex]["labelName"]}
          onChange={(event) => {
            formGroup[parentIndex]["labelName"] = event.target.value;
            props?.handleChange(formGroup);
          }}
          helperText={isErrorFormGroup[parentIndex]?.labelname || "請輸入問題"}
          id="demo-helper-text-aligned"
        />
      </Grid>
      <Grid
        container
        spacing={2}
        size={{
          xs: 12,
          md: 9,
          lg: 9,
        }}
      >
        {(props.type === "checkBox" || props.type === "dropDown") &&
          optionValue?.map((item, index) => {
            return (
              <Grid
                key={index}
                container
                gap={2}
                size={{
                  xs: 12,
                  md: 3,
                  lg: 3,
                }}
              >
                <TextField
                  error={
                    !!isErrorFormGroup[parentIndex]?.["optionValue"][index]
                      ?.label
                  }
                  value={item["label"]}
                  onChange={(event) => {
                    const temp = { ...optionValueCopy[index] };
                    temp["label"] = event.target.value;
                    temp["value"] = event.target.value;
                    optionValueCopy[index] = temp;
                    formGroup[parentIndex]["optionValue"] = optionValueCopy;
                    props?.handleChange(formGroup);
                  }}
                  helperText={
                    isErrorFormGroup[parentIndex]?.["optionValue"]?.[index]
                      ?.label || `請輸入 ${props.type}${index + 1} 值`
                  }
                  id="demo-helper-text-aligned"
                />
              </Grid>
            );
          })}
      </Grid>
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        size={{
          xs: 1,
          md: 1,
          lg: 1,
        }}
      >
        <IconButton
          component="label"
          onClick={() => {
            formGroup.splice(parentIndex, 1);
            props?.handleChange(formGroup);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Grid>
    </React.Fragment>
  );
}

export function UpperForm(props) {
  const { formDetail, setFormDetail, isErrorFormDetail, optionList } = props;

  const moment = extendMoment(Moment);

  return (
    <StyledPaper page={"yes"}>
      <ThemeProvider theme={{}}>
        <Container>
          <Stack
            direction={"row"}
            spacing={3}
            justifyContent={"center"}
            alignItems={"flex-start"}
          >
            <TextField
              sx={{ width: 300 }}
              id="outlined-basic"
              label="標題"
              helperText={isErrorFormDetail.title}
              error={!!isErrorFormDetail.title}
              value={formDetail.title}
              variant="outlined"
              InputProps={{
                startAdornment: " ",
              }}
              onChange={(event) => {
                setFormDetail((prev) => ({
                  ...prev,
                  title: event.target.value,
                }));
              }}
            />
            <StaffSelection
              formDetail={formDetail}
              setFormDetail={setFormDetail}
              staffOptions={optionList}
            ></StaffSelection>
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <FormControl sx={{ flex: 7 }}>
                <DatePicker
                  label="開始日期"
                  maxDate={formDetail.endDate}
                  value={formDetail.startDate}
                  renderInput={(props) => (
                    <TextField color="success" {...props} />
                  )}
                  onChange={(value) => {
                    const startDate = moment(value).format("YYYY-MM-DD");
                    setFormDetail((prev) => ({ ...prev, startDate }));
                  }}
                />
              </FormControl>
              <Box sx={{ flex: 1 }}>
                <Divider />
              </Box>
              <FormControl sx={{ flex: 7 }}>
                <DatePicker
                  minDate={formDetail.startDate}
                  label="結束日期"
                  value={formDetail.endDate}
                  renderInput={(props) => (
                    <TextField color="success" {...props} />
                  )}
                  onChange={(value) => {
                    const endDate = moment(value).format("YYYY-MM-DD");
                    setFormDetail((prev) => ({ ...prev, endDate }));
                  }}
                />
              </FormControl>
            </Stack>
          </Stack>
        </Container>
      </ThemeProvider>
    </StyledPaper>
  );
}
